import React from 'react';

import BasePage from 'components/Page';
import Content from 'components/Content';

/* Privacy policy page. */
export default class PrivacyPolicy extends BasePage {
  render() {
    // parent, for lifecycle logging
    super.render();

    // render
    return <Content name="privacyPolicy" showError={true} />;
  }
}
